// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-select {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  touch-action: none;
}
.simple-select .select-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  pointer-events: initial;
  z-index: 9;
  background-color: var(--motes-black);
  opacity: 0.95;
  transition: 0.3s;
  display: flex;
}
.simple-select .select-overlay.animate {
  animation: fadeIn 0.3s;
}
.simple-select .hide-overlay {
  pointer-events: none;
  background: transparent;
  opacity: 0 !important;
  transition: 0.5s;
}
.simple-select .overlay-container {
  backface-visibility: hidden;
  transform: translateZ(1);
  position: relative;
  width: 98vw;
  max-width: 400px;
  max-height: 100%;
  min-height: 100px;
  overflow-y: auto;
  overflow-y: auto;
  margin: auto;
  opacity: 1;
  transition: 0.4;
  position: relative;
  padding: 10px;
  transition: 1s;
  z-index: 10;
  pointer-events: initial;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 8vh;
}
@media only screen and (max-height: 600px) {
  .simple-select .overlay-container {
    margin-top: 20px;
  }
}
.simple-select .hide-container {
  transform: translate(-50%, -150%);
  transition: 1s;
  opacity: 0;
  pointer-events: none;
}
.simple-select .select-box {
  height: 100%;
  padding: 10px;
  overflow-y: auto;
  overscroll-behavior: contain;
  max-height: calc(90vh - var(--safe-area-bottom));
  box-sizing: border-box;
  scrollbar-width: none;
  touch-action: none;
}
.simple-select .select-box.animate {
  animation: slideFromRight 0.3s;
}
.simple-select .select-box::-webkit-scrollbar {
  display: none;
}
.simple-select .select-box.transparent {
  background-color: transparent;
  border: none;
  box-shadow: none;
  max-height: 95vh;
}
.simple-select .select-box.transparent hr {
  display: none;
}
.simple-select .select-box.transparent .button-outline {
  color: var(--primary-color);
}
.simple-select .select-box .button-container {
  display: flex;
  justify-content: center;
}
.simple-select .select-box .button-container button {
  width: 100%;
  margin: 0 var(--motes-padding);
}
.simple-select hr {
  background: #ddd;
  margin: 20px 0;
  height: 1px;
  border: none;
  opacity: 1;
}

@keyframes slideFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/simple-select/simple-select.component.scss"],"names":[],"mappings":"AAAA;EAEI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AAAJ;AAEI;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAAR;AAEQ;EACI,sBAAA;AAAZ;AAII;EACI,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AAFR;AAKI;EAEI,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AALR;AAQI;EACI;IACI,gBAAA;EANV;AACF;AASI;EACI,iCAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AAPR;AAUI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,gDAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AARR;AAUQ;EACI,8BAAA;AARZ;AAYQ;EACI,aAAA;AAVZ;AAaQ;EACI,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAXZ;AAaY;EACI,aAAA;AAXhB;AAcY;EACI,2BAAA;AAZhB;AAgBQ;EACI,aAAA;EACA,uBAAA;AAdZ;AAgBY;EACI,WAAA;EACA,8BAAA;AAdhB;AAuBI;EACI,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AArBR;;AA6BA;EACI;IACI,2BAAA;EA1BN;EA4BE;IACI,yBAAA;EA1BN;AACF;AA6BA;EACI;IACI,UAAA;EA3BN;EA6BE;IACI,UAAA;EA3BN;AACF","sourcesContent":[".simple-select {\n\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 5;\n    touch-action: none; // Prevent pull-to-refresh on iOS 15\n\n    .select-overlay {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        width: 100%;\n        pointer-events: initial;\n        z-index: 9;\n        background-color: var(--motes-black);\n        opacity: 0.95;\n        transition: .3s;\n        display: flex;\n\n        &.animate {\n            animation: fadeIn 0.3s;\n        }\n    }\n\n    .hide-overlay {\n        pointer-events: none;\n        background: transparent;\n        opacity: 0 !important;\n        transition: .5s;\n    }\n\n    .overlay-container {\n        // Fix blury issue with translating overlay with % in chrome\n        backface-visibility: hidden;\n        transform: translateZ(1);\n        position: relative;\n        width: 98vw;\n        max-width: 400px;\n        max-height: 100%;\n        min-height: 100px;\n        overflow-y: auto;\n        overflow-y: auto;\n        margin: auto;\n        opacity: 1;\n        transition: .4;\n        position: relative;\n        padding: 10px;\n        transition: 1s;\n        z-index: 10;\n        pointer-events: initial;\n        // background-color: #ffffff8e;\n        overflow: hidden;\n        box-sizing: border-box;\n        border-radius: 3px;\n        margin-top: 8vh;\n    }\n\n    @media only screen and (max-height: 600px) {\n        .overlay-container {\n            margin-top: 20px;\n        }\n    }\n\n    .hide-container {\n        transform: translate(-50%, -150%);\n        transition: 1s;\n        opacity: 0;\n        pointer-events: none;\n    }\n\n    .select-box {\n        height: 100%;\n        padding: 10px;\n        overflow-y: auto;\n        overscroll-behavior: contain;\n        max-height: calc(90vh - var(--safe-area-bottom));\n        box-sizing: border-box;\n        scrollbar-width: none; // Hide scrollbar in firefox\n        touch-action: none;  // Prevent pull-to-refresh on iOS 15\n\n        &.animate {\n            animation: slideFromRight 0.3s;\n        }\n        \n        // Hide scrollbar everywhere but firefox\n        &::-webkit-scrollbar {\n            display: none;\n        }\n\n        &.transparent {\n            background-color: transparent;\n            border: none;\n            box-shadow: none;\n            max-height: 95vh;\n\n            hr {\n                display: none;\n            }\n\n            .button-outline {\n                color: var(--primary-color)\n            }\n        }\n\n        .button-container {\n            display: flex;\n            justify-content: center;\n\n            button {\n                width: 100%;\n                margin: 0 var(--motes-padding);\n            }\n        }\n    }\n\n    // .motes-col {\n    //     padding: 0;\n    // }\n\n    hr {\n        background: #ddd;\n        margin: 20px 0;\n        height: 1px;\n        border: none;\n        opacity: 1;\n    }\n\n    // .motes-row {\n    //     gap: 1em;\n    // }\n}\n\n@keyframes slideFromRight {\n    from {\n        transform: translateX(100%);\n    }\n    to {\n        transform: translateX(0%);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
